package one.healthium.insights.ui.components.items

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.AnchorState
import one.healthium.insights.ui.components.ContentEntryItem
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun ContentColumn(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Column,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    actionButton: String?,
    onTextActionClicked: () -> Unit,
    isMetrics: Boolean,
) {
    Column(
        modifier = modifier
            .padding(entry.insets.toPaddingValues())
            .clickable(
                enabled = entry.action != null,
                onClick = { entry.action?.let(onActionClicked) }
            )
    ) {
        entry.content.forEach { item ->
            ContentEntryItem(
                entry = item,
                anchorState = anchorState,
                onActionClicked = onActionClicked,
                actionButton = actionButton,
                onTextActionClicked = onTextActionClicked,
                isMetrics = isMetrics,
            )
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun ContentColumnPreview() {
    AppTheme {
        ContentColumn(
            entry = ContentEntry.Column(
                content = listOf(
                    ContentEntry.PlainText("Plain text", null, null),
                    ContentEntry.Button(
                        text = "Button",
                        height = 37,
                        style = null,
                        containerColor = null,
                        action = ActionModel.Category(id = "id"),
                        insets = null,
                    )
                ),
                insets = null,
                action = null,
            ),
            anchorState = AnchorState(),
            onActionClicked = {},
            actionButton = null,
            onTextActionClicked = {},
            isMetrics = false,
        )
    }
}